import { JsBarcode } from 'jsbarcode'
import * as printConst from '@/api/print/constant.js';

export const getBarcode = (barcode, barcodeRule) => {
  /** ******************生成barcode **************/
  //   1.vue中声明
  //   <div id ="barcodeWrapper" type="hidden">
  //      <svg id="barcode"></svg>
  //   </div>
  //   2.content.barcode:barcode值
  //   3.ejs中声明<%-barcode%>
  if (!barcode) {
    return "";
  }

  // 如果为云打印，直接返回空串
  if (printConst.DEFINE_PRINT_WAY === printConst.PRINT_WAY.CLOUD_PRINT) {
    return "";
  }

  if (!barcodeRule) {
    Object.assign(printConst.defaultBarcodeRule, barcodeRule)
  }

  window.JsBarcode('#barcode', barcode, printConst.defaultBarcodeRule)
  setImgProp(printConst.defaultBarcodeRule);
  let rawConent = document.getElementById('barcodeWrapper').innerHTML
  return rawConent;
  /** ******************生成barcode **************/
}

/**
 * 设置Img属性（高度和宽度）
 * @param barcodeRule
 */
export const setImgProp = (barcodeRule) => {
  let img_width = barcodeRule.img_width;
  let img_height = barcodeRule.img_height;
  if (img_width && img_height) {
    let domBarcode = document.getElementById('barcode');
    domBarcode.setAttribute("width", img_width);
    domBarcode.setAttribute("height", img_height);
  }
}
